'use client';
import { FormControl, RoleSelect } from '@baseball-near-you/ui';
import { useFormContext } from 'react-hook-form';

export function FormRoleSelect() {
  const { watch, setValue } = useFormContext();
  const role = watch('role');

  return (
    <FormControl name="role" label="Role">
      <RoleSelect
        onSelect={(role) => {
          setValue('role', role);
        }}
        val={role}
      />
    </FormControl>
  );
}
